import React, { useState } from 'react';
import TableHeader from './ConfigurationSetTableHeader'
import TableRow from './ConfigurationSetTableRow';
import { CONFIGURATION_SET_COLUMNS } from './configurationSetColumns';

const buildInitialColumnWidths = () => CONFIGURATION_SET_COLUMNS.reduce(
    (acc, col) => {
        acc[col.key] = col.width;
        return acc;
    },
    {},
);

/**
 * @param {{
 *  className?: HTMLAttributes<HTMLDivElement>.className?: string | undefined;
 *  sortBySelected: string;
 *  sortBy: (sortIndex: string) => void;
 *  sortOrder: "Ascending" | "Descending";
 *  filteredsettingList: *[];
 *  dateFormat: string;
 *  hyperfinds: *[];
 *  rightPanelHandler: (sideAction: any, selectedItem: any) => void;
 *  isArchive: boolean?;
 * }} param0
 */
const ConfigurationSetTable = ({
    className,
    sortBySelected,
    sortBy,
    sortOrder,
    filteredsettingList,
    dateFormat,//TODO 2023/05/05 - kathy - Use user date format set on hris
    hyperfinds,
    rightPanelHandler,
    isArchive = false,
}) => {
    const [columnWidths, setColumnWidths] = useState(buildInitialColumnWidths);

    return (
        <div className={className || undefined}>
            <TableHeader
                sortBy={sortBy}
                sortBySelected={sortBySelected}
                sortOrder={sortOrder}
                columnWidths={columnWidths}
                onColumnWidthsChange={setColumnWidths}
            />
            <div className="cstr-table-body">
                {filteredsettingList.map((bid, index) =>
                    <TableRow
                        key={bid.id}
                        dateFormat={dateFormat}
                        showRightPanel={rightPanelHandler}
                        item={bid}
                        index={index}
                        hyperFindList={hyperfinds}
                        isEditable={!isArchive}
                        isDeletable={!isArchive}
                        columnWidths={columnWidths}
                    />
                )}
            </div>
        </div>
    );
};

export default ConfigurationSetTable;
